<template>
  <div class="filter-section">
    <div class="filter-header">
      <h3 class="filter-title">Filters</h3>
      <v-btn
        x-small
        text
        class="clear-btn"
        :disabled="!hasActiveFilters"
        @click="$emit('reset-filters')"
      >
        <v-icon small left>mdi-refresh</v-icon>
        Reset
      </v-btn>
    </div>

    <v-expansion-panels flat class="filter-panels" v-model="activePanel">
      <v-expansion-panel
        v-for="(filter, i) in filters"
        :key="i"
        class="filter-panel"
      >
        <v-expansion-panel-header>
          <div class="panel-header-content">
            <v-icon color="primary" class="filter-icon">
              {{ filter.icon }}
            </v-icon>
            <span class="filter-label">{{ filter.title }}</span>
            <v-chip
              x-small
              label
              class="filter-count"
              v-if="getSelectedCount(filter)"
            >
              {{ getSelectedCount(filter) }}
            </v-chip>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div class="checkbox-container">
            <v-checkbox
              v-for="option in filter.options"
              :key="option.id"
              v-model="option.selected"
              :label="option.label"
              dense
              hide-details
              class="filter-checkbox"
              @change="$emit('option-selected', { option, filterIndex: i })"
            >
              <template v-slot:label>
                <div class="checkbox-label">
                  <span>{{ option.label }}</span>
                  <v-chip
                    x-small
                    :color="option.color"
                    text-color="white"
                    class="count-chip"
                  >
                    {{ getOptionCount(option) }}
                  </v-chip>
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: "FilterSection",

  props: {
    filters: {
      type: Array,
      required: true,
    },
    hasActiveFilters: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    activePanel: null,
  }),

  methods: {
    getSelectedCount(filter) {
      return filter.options.filter((opt) => opt.selected).length;
    },

    getOptionCount(option) {
      this.$emit("get-option-count", option);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-section {
  margin-bottom: 32px;

  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .filter-title {
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #64748b;
    }
  }
}

.filter-panels {
  .filter-panel {
    border-radius: 12px;
    margin-bottom: 8px;
    border: 1px solid #e2e8f0;
    overflow: hidden;

    &::before {
      display: none;
    }
  }

  .panel-header-content {
    display: flex;
    align-items: center;

    .filter-icon {
      margin-right: 12px;
      opacity: 0.8;
    }

    .filter-label {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
    }

    .filter-count {
      background: #e2e8f0;
      color: #475569;
    }
  }
}

.checkbox-container {
  padding: 8px 0;

  .checkbox-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .count-chip {
      margin-left: 8px;
    }
  }
}
</style>
